import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '@core/constants/endpoints';
import { Timezone } from '@app/shared/models/timezone.model';
import { map } from 'rxjs/operators';
import { TimezoneAdapter } from '@core/services/adapters/timezone.adapter';

@Injectable()
export class TimezoneService {
    constructor(private http: HttpClient, private adapter: TimezoneAdapter) {}

    getTimezones(): Observable<Timezone[]> {
        return this.http.get(ENDPOINTS.apis.timezones).pipe(
            map((result: any[]) => {
                const timezones = result.map((data) => this.adapter.adapt(data));

                timezones.sort((a, b) => {
                    const aOffset = Number(a.offset.replace(':', '.'));
                    const bOffset = Number(b.offset.replace(':', '.'));

                    return aOffset < bOffset ? -1 : 1;
                });

                return timezones;
            })
        );
    }
}
